<!-- 活动规则 -->
<template>
  <div class="page page-rules">
    <div class="page__inner">
    <k-block name="rules_2_body" />
    </div>
  </div>
</template>

<script>
  export default {
  };
</script>
